import Store from "@/store/index";

import UiKit from "@/pages/uikit";
import UiKitForm from "@/pages/uikit/form";
import UiKitModals from "@/pages/uikit/modals";
import UiKitButtons from "@/pages/uikit/buttons";
import UiKitCharts from "@/pages/uikit/charts";
import UiKitOther from "@/pages/uikit/other";

export default [
    {
        path: "/uikit",
        component: UiKit,
        children: [
            {
                path: "/uikit",
                name: "uikit-form",
                component: UiKitForm,
                meta: {
                    title: "UiKit — form",
                },
            },
            {
                path: "/uikit",
                name: "uikit-modals",
                component: UiKitModals,
                meta: {
                    title: "UiKit — modals",
                },
            },
            {
                path: "/uikit",
                name: "uikit-buttons",
                component: UiKitButtons,
                meta: {
                    title: "UiKit — buttons",
                },
            },
            {
                path: "/uikit/charts",
                name: "uikit-charts",
                component: UiKitCharts,
                meta: {
                    title: "UiKit — charts",
                },
            },
            {
                path: "/uikit/other",
                name: "uikit-other",
                component: UiKitOther,
                meta: {
                    title: "UiKit — other",
                },
            },
        ],
        beforeEnter: (to, from, next) => {
            if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                next();
            } else {
                window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
            }
        },
    },
];
